import { FormLabel, FormLabelProps } from '@material-ui/core';
import React from 'react';
import { useController } from 'react-hook-form';
import { useFieldControllerContext } from './FieldControllerContext';
import { fieldHasError } from './formUtils';

const FieldFormLabel: React.FC<FormLabelProps> = props => {
  const { name } = useFieldControllerContext();
  const { fieldState } = useController({ name });

  return (
    <FormLabel
      id={`${name}-label`}
      htmlFor={name}
      error={fieldHasError(fieldState)}
      {...props}
    />
  );
};

export default FieldFormLabel;
